import React from 'react'
import { Button, Menu, MenuItem } from '@mui/material'

export interface QuickRepliesMenuProps {
  items?: string[]
  onPick: (text: string) => void
  disabled?: boolean
}

const DEFAULT_ITEMS = [
  'Thanks for getting in touch!',
  'We will read this on air shortly.',
  'Can you share more details?',
]

const QuickRepliesMenu: React.FC<QuickRepliesMenuProps> = ({ items = DEFAULT_ITEMS, onPick, disabled = false }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (text: string) => () => {
    onPick(text)
    handleClose()
  }

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleOpen} disabled={disabled}>
        Quick reply <span aria-hidden style={{ marginLeft: 4 }}>▾</span>
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        {items.map((text) => (
          <MenuItem key={text} onClick={handleSelect(text)} disabled={disabled}>
            {text}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default QuickRepliesMenu
